export class Maraton {
  public id: number;
  public titulo: string;
  public subtitulo: string;
  public texto: string;
  public imagen: string;
  public fecha: string;
  public link_clasificacion: string;
  public link_album: string;
  constructor() { }
}
